const TaskProgramItemGridPluginSettings: IPluginSettings = {
    name: 'Склады',
    mnemocode: 'task_program_item_plugin',
    permission: 'TaskProgram',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'ИД',
            visibility: false,
            width: 100
        },
        {
            order: 1,
            propertyName: 'storeName',
            propertyType: 'string',
            displayName: 'Склады',
            visibility: true,
            width: 180
        },
        {
            order: 2,
            propertyName: 'dateDeleted',
            propertyType: 'datetime',
            displayName: 'Дата удаления',
            visibility: true,
            width: 150
        },
        {
            order: 3,
            propertyName: 'dateModified',
            propertyType: 'datetime',
            displayName: 'Дата изменение',
            visibility: true,
            width: 150
        },
        {
            order: 4,
            propertyName: 'deleted',
            propertyType: 'boolean',
            displayName: 'Удален',
            visibility: false,
            favoriteFilter: false,
            width: 150
        }
    ]
}

export default TaskProgramItemGridPluginSettings